module.exports = {
      id: "logout-mobile-usage",
      viewBox: "0 0 20.886 28.808",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#logout-mobile",
      toString: function () {
        return this.url;
      }
    }